// Consistency Rules: the routes and the sidebar rows of `wealth.compliance.consistency-rules` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.consistency-rules',
    routes: [
        // SEP-243 section 39 - the consistency rule book.
        {
            frontend: 'comply',
            path: 'consistency-rules',
            lazy: () => import('@/pages/comply/consistency-rules/page'),
        },
    ],
    nav: [
        // SEP-243 section 39 - the R-01 to R-49 rule book. Compliance changes a
        // tier and a threshold here, and never in a release.
        {
            frontend: 'comply',
            key: 'consistency-rules',
            label: 'Consistency Rules',
            href: '/comply/consistency-rules',
            icon: 'ScrollText',
            group: 'clients-kyc',
            order: 340,
        },
    ],
});
